/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import ModulesContext from "./ModulesContext";
import { useSelector } from "react-redux";
import NotificationsIndicator from "components/Home/Notifications/Indicator";
import { getEnvVar } from "utils/env";
import { hasElements } from "utils/arrays";
import { Tabs } from "components/common_components/Tabs";
import { useNotifications } from "components/Home/Notifications/Notifications";

function MenuBar({ children, history, match }) {
    const { user } = useSelector((state) => state.Login);
    const { currentFileCase, header } = useContext(ModulesContext);
    const notifications = useNotifications("menu-bar");

    const options = [
        { index: 0, label: "Clients", path: `${match.path}/list`, icon: "list" },
        { index: 1, label: "Personal", path: `${match.path}/personal-info`, icon: "personal-info", disabled: !Boolean(currentFileCase) },
        { index: 2, label: "Attachments", path: `${match.path}/attachments`, icon: "attachment", disabled: !Boolean(currentFileCase) },
        { index: 3, label: "Accounting", path: `${match.path}/accounting`, icon: "accounting", disabled: !Boolean(currentFileCase) },
        { index: 4, label: "Progress", path: `${match.path}/progress-info`, icon: "information", disabled: !Boolean(currentFileCase) },
        { index: 5, label: "Reports", path: `${match.path}/reports`, icon: "reports", disabled: !Boolean(currentFileCase) },
        { index: 6, label: "Workflow", path: `${match.path}/workflow`, icon: "workflow", disabled: !Boolean(currentFileCase) },
        {
            index: 7,
            label: "Chat",
            path: `${match.path}/chat`,
            icon: "chat",
            disabled: !Boolean(currentFileCase),
            notificationsKeyIdentity: getEnvVar("REACT_APP_CHAT_IDENTITY"),
        },
    ];

    const [selectedOption, setSelectedOption] = useState(options[0]);

    useEffect(() => {
        const newSelectedOption = options.find((o) => history.location.pathname.startsWith(o.path));
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }, [history.location.pathname]);

    function handleChange(_, newIndex) {
        history.push(options.find((o) => o.index === newIndex).path);
    }

    const getOptions = () => {
        if (user.canChatWithClients) {
            return options;
        }
        return options.filter((x) => !String(x.path).endsWith("/chat"));
    };

    const renderTabLabel = (label, notificationsKeyIdentity) => {
        if (notificationsKeyIdentity) {
            return (
                <>
                    {label}
                    <NotificationsIndicator
                        id={`menu-tab-${notificationsKeyIdentity}`}
                        identity={notificationsKeyIdentity}
                        getter={() => notificationsGetter(notificationsKeyIdentity)}
                        className="in-tab"
                    />
                </>
            );
        }
        return label;
    };

    const notificationsGetter = (notificationsKeyIdentity) => {
        if (currentFileCase && currentFileCase.client && hasElements(currentFileCase.client.conversations)) {
            const activeClientConversation = currentFileCase.client.conversations.find((x) => x.state === "active");
            if (activeClientConversation) {
                return notifications[notificationsKeyIdentity].filter((n) => n.conversationSid === activeClientConversation.sid);
            }
        }
        return [];
    };

    return (
        <>
            {header}
            <Tabs options={getOptions()} selectedOption={selectedOption} onChange={handleChange} renderTabLabel={renderTabLabel}>
                {children}
            </Tabs>
        </>
    );
}

export default withRouter(MenuBar);
